import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import * as myGlobal from '../../../global';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie-service';
import 'rxjs/add/operator/do';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    constructor( public auth: AuthService, private cookieService: CookieService ) {
    }

    intercept( request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
        request = request.clone( {
            setHeaders: {
                [ myGlobal.CONTENT_TYPE ]: 'application/json',
                [ myGlobal.TOKEN ]: this.cookieService.get( 'Token' ),
                [ myGlobal.PROVIDER ]: this.cookieService.get( 'Provider' )
            }
        } );
        return next.handle( request );
    }
}
